import axios, { AxiosPromise } from 'axios';
import { IAttendanceMessageReq, IAttendanceReq, IDtttScoreReq, IFeedbackReq, IFeedbackTaskParams, IGetAttendances, IGetClassTests, IGetDtttScores, IGetEvaluationPeriod, IGetFeedbackTasks, IGetHomeworkItems, IGetHomeworkScores, IGetParticipationItems, IGetParticipationScores, IGetPbtScores, IGetPortfolio, IGetPortfolios, IGetRecordItemOptions, IGetRecords, IGetSavedComments, IGetSavedFeedback, IGetStudentFile, IGetStudentFiles, IGetStudentWriting, IGetTargetStudents, IGetTestComments, IGetTestScore, IGetTestStudents, IGetTutorClasses, IHomeworkScoreReq, IParticipationScoreDelete, IParticipationScoreReq, IPbtScoreReq, IPortfolioParams, IPortfolioReq, ITestCodeReq, IGetPortfolioSubject } from '../models/tutor.model';
import QueryString from 'qs';

const url = '/mgmt/tutor';

// 수업 학급 목록
export const getTutorClasses = (): AxiosPromise<IGetTutorClasses> => {
  return axios.get(`${url}/classes/my-classes`);
};

// 담당 학급 목록
export const getTutorClasses2 = (): AxiosPromise<IGetTutorClasses> => {
  return axios.get(`${url}/classes/charge-classes`);
};

// 관리대상 학생 목록
export const getTargetStudents = (classCode: string, timetableDate: string): AxiosPromise<IGetTargetStudents> => {
  return axios.get(`${url}/classes/management-target/${classCode}/${timetableDate}`);
};

// 출결 탭
export const getAttendances = (classCode: string, timetableCode: number): AxiosPromise<IGetAttendances> => {
  return axios.get(`${url}/attendance-management/${classCode}/attendance/${timetableCode}`);
};

export const updateAttendance = (classCode: string, timetableCode: number, data: IAttendanceReq): AxiosPromise => {
  return axios.post(`${url}/attendance-management/${classCode}/attendance/${timetableCode}`, data);
};

export const sendAttendanceMessages = (data: IAttendanceMessageReq[]): AxiosPromise => {
  return axios.post(`${url}/attendance-management/students/send-sms`, data);
};

// 성적 탭
export const getRecords = (timetableCode: number, learningTypeCode: string): AxiosPromise<IGetRecords> => {
  return axios.get(`${url}/grade-management/${timetableCode}/${learningTypeCode}`);
};

export const getHomeworkItems = (timetableCode: number, learningTypeCode: string): AxiosPromise<IGetHomeworkItems> => {
  return axios.get(`${url}/grade-management/homework/${timetableCode}/${learningTypeCode}`);
};

export const getHomeworkItemOptions = (evaluationTypeCode: number): AxiosPromise<IGetRecordItemOptions> => {
  return axios.get(`${url}/grade-management/homework/conversion-list/${evaluationTypeCode}`);
};

export const getHomeworkScores = (timetableCode: number): AxiosPromise<IGetHomeworkScores> => {
  return axios.get(`${url}/grade-management/homework/${timetableCode}`);
};

export const createHomeworkScores = (timetableCode: number, data: IHomeworkScoreReq): AxiosPromise => {
  return axios.post(`${url}/grade-management/${timetableCode}/homework`, data);
};

export const updateHomeworkScores = (timetableCode: number, data: IHomeworkScoreReq): AxiosPromise => {
  return axios.put(`${url}/grade-management/${timetableCode}/homework/modify`, data);
};

export const createHomeworkScoresLegacy = (data: IHomeworkScoreReq): AxiosPromise => {
  return axios.post(`${url}/grade-management/homework`, data);
};

export const updateHomeworkScoresLegacy = (data: IHomeworkScoreReq): AxiosPromise => {
  return axios.put(`${url}/grade-management/homework/modify`, data);
};

export const getPbtScores = (timetableCode: number): AxiosPromise<IGetPbtScores> => {
  return axios.get(`${url}/grade-management/pbt/${timetableCode}`);
};

export const postPbtScores = (req: IPbtScoreReq[]): AxiosPromise => {
  return axios.post(`${url}/grade-management/pbt`, req);
};

export const putPbtScores = (req: IPbtScoreReq[]): AxiosPromise => {
  return axios.put(`${url}/grade-management/pbt`, req);
};

export const getDtttScores = (timetableCode: number, classCode: string): AxiosPromise<IGetDtttScores> => {
  return axios.get(`${url}/grade-management/${timetableCode}/${classCode}/dttt`);
};

export const createDtttScores = (timetableCode: number, data: IDtttScoreReq[]): AxiosPromise => {
  return axios.post(`${url}/grade-management/${timetableCode}/dttt`, data);
};

export const updateDtttScores = (timetableCode: number, data: IDtttScoreReq[]): AxiosPromise => {
  return axios.put(`${url}/grade-management/${timetableCode}/dttt`, data);
};

export const createDtttScoresLegacy = (data: IDtttScoreReq[]): AxiosPromise => {
  return axios.post(`${url}/grade-management/dttt`, data);
};

export const updateDtttScoresLegacy = (data: IDtttScoreReq[]): AxiosPromise => {
  return axios.put(`${url}/grade-management/dttt`, data);
};

export const getParticipationItems = (timetableCode: number): AxiosPromise<IGetParticipationItems> => {
  return axios.get(`${url}/grade-management/participation/time-list/${timetableCode}`);
};

export const getParticipationItemOptions = (): AxiosPromise<IGetRecordItemOptions> => {
  return axios.get(`${url}/grade-management/participation/evaluation`);
};

export const getParticipationScores = (timetableCode: number, classTimeSeq: number): AxiosPromise<IGetParticipationScores> => {
  return axios.get(`${url}/grade-management/participation/${timetableCode}/${classTimeSeq}`);
};

export const updateParticipationScores = (data: IParticipationScoreReq): AxiosPromise => {
  return axios.post(`${url}/grade-management/participation`, data);
};

export const deleteParticipationScores = (timetableCode: number, data: IParticipationScoreDelete[]): AxiosPromise => {
  return axios.post(`${url}/grade-management/participation/remove/${timetableCode}`, data);
};

// Test 탭
export const getClassTests = (classCode: string): AxiosPromise<IGetClassTests> => {
  return axios.get(`${url}/regular-test/${classCode}`);
};

export const getTestStudents = (classCode: string, scheduleCode: number): AxiosPromise<IGetTestStudents> => {
  return axios.get(`${url}/regular-test/${classCode}/test-students/${scheduleCode}`);
};

export const createTestCodes = (classCode: string, scheduleCode: number, data: ITestCodeReq[]): AxiosPromise => {
  return axios.post(`${url}/regular-test/${classCode}/${scheduleCode}`, data);
};

export const getTestScore = (examTestCode: number): AxiosPromise<IGetTestScore> => {
  return axios.get(`${url}/regular-test/${examTestCode}/student-report`);
};

export const getTestComments = (examTestCode: number): AxiosPromise<IGetTestComments> => {
  return axios.get(`${url}/regular-test/${examTestCode}/comment`);
};

export const createTestComments = (examTestCode: number, data: {
  teacherMemCode: string;
  comment: string;
  openYn: string;
}): AxiosPromise => {
  return axios.post(`${url}/regular-test/${examTestCode}/comment`, data);
};

export const updateTestComments = (examTestCode: number, data: {
  commentCode: number;
  comment: string;
  openYn: string;
}): AxiosPromise => {
  return axios.put(`${url}/regular-test/${examTestCode}/comment-modify`, data);
};

export const openTestResults = (data: {
  examTestCode: number;
  openYn: string;
}[]): AxiosPromise => {
  return axios.put(`${url}/regular-test/report/open`, data);
};

// 재채점
export const remarkTestScores = (scheduleCode: number): AxiosPromise => {
  return axios.put(`${url}/regular-test/retry-evaluation/${scheduleCode}`);
};

// 이러닝 평가
export const getFeedbackTasks = (params: IFeedbackTaskParams): AxiosPromise<IGetFeedbackTasks> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${url}/learning-evaluation/feedback-list?${qsParams}`);
};

export const getSavedFeedback = (resultCode: number): AxiosPromise<IGetSavedFeedback> => {
  return axios.get(`${url}/learning-evaluation/feedback/call-up/${resultCode}`);
};

export const getSavedComments = (resultCode: number, feedbackTypeCode: string): AxiosPromise<IGetSavedComments> => {
  return axios.get(`${url}/learning-evaluation/feedback/comment/${resultCode}/${feedbackTypeCode}`);
};

export const createSpeakingFeedback = (rubricNo: number, data: IFeedbackReq): AxiosPromise => {
  return axios.post(`${url}/learning-evaluation/feedback/speaking/${rubricNo}`, data);
};

export const createWritingFeedback = (rubricNo: number, data: IFeedbackReq): AxiosPromise => {
  return axios.post(`${url}/learning-evaluation/feedback/writing/${rubricNo}`, data);
};

export const postWritingSpeakingFeedback = (rubricNo: number, req: IFeedbackReq): AxiosPromise => {
  return axios.post(`${url}/learning-evaluation/feedback/speaking-writing/${rubricNo}`, req);
};

export const getStudentFile = (resultCode: number, activityType: string): AxiosPromise<IGetStudentFile> => {
  return axios.get(`${url}/learning-evaluation/student/file/${resultCode}/${activityType}`);
};

export const getStudentFiles = (resultCode: number, activityType: string): AxiosPromise<IGetStudentFiles> => {
  return axios.get(`${url}/learning-evaluation/student/file/${resultCode}/${activityType}`);
};

export const getStudentWriting = (resultCode: number): AxiosPromise<IGetStudentWriting> => {
  return axios.get(`${url}/learning-evaluation/student-answer/${resultCode}`);
};

// 포트폴리오
export const getPortfolios = (params: IPortfolioParams): AxiosPromise<IGetPortfolios> => {
  return axios.get(`${url}/portfolio`, { params });
};

export const getPortfolio = (classCode: string, resultCode: number): AxiosPromise<IGetPortfolio> => {
  return axios.get(`${url}/portfolio/${classCode}/${resultCode}`);
};

export const approveProfolio = (data: IPortfolioReq): AxiosPromise => {
  return axios.post(`${url}/portfolio`, data);
};

export const multiApprovalProfolio = (data: any): AxiosPromise => {
  return axios.post(`${url}/portfolio/multiApproval`, data);
};

export const getDashboardPortfolios = (semesterCode: number): AxiosPromise<IGetPortfolios> => {
  return axios.get(`${url}/portfolio/dash-board?semesterCode=${semesterCode}`);
};

//과목
export const getPortfolioSubjectList = (): AxiosPromise<IGetPortfolioSubject> => {
  return axios.get(`${url}/portfolio/subjectList`)
}

// 레벨업
export const getEvaluationPeriod = (classCode: string): AxiosPromise<IGetEvaluationPeriod> => {
  return axios.get(`${url}/classes/level-up/elearning-date/${classCode}`);
};
